import DashboardListCard from "./DashboardListCard";

export default DashboardListCard;
